import { authFetch } from "@/utils/authFetch";

function getEdgeBaseUrl() {
  const url = import.meta.env.VITE_SUPABASE_URL;
  if (!url) throw new Error("VITE_SUPABASE_URL is missing");
  return `${url}/functions/v1`;
}

// adminCreateUser removed — all admin user creation now uses
// supabase.functions.invoke("create-user") edge function directly


export async function adminUpdateUser(payload: {
  user_id: string;
  email?: string;
  password?: string;
  name?: string;
}) {
  const res = await authFetch(`${getEdgeBaseUrl()}/admin-users/update-user`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return res.json();
}
